import React from 'react';
import {useTranslation} from "react-i18next";
import {QRCodeSVG} from "qrcode.react";

const QrCodeOverlay = ({isOpen, title, url, onClose}) => {
    const {t} = useTranslation();

    if (!isOpen || !url) return null;

    return (
        <div
            className="fixed inset-0 z-[100] flex flex-col justify-center items-center bg-black/95 backdrop-blur-sm animate-fade-in">

            <button
                onClick={onClose}
                className="absolute top-6 right-6 bg-white/10 hover:bg-white/20 text-white rounded-full p-3 transition-colors z-50"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
            </button>

            <div className="bg-white p-8 rounded-3xl shadow-2xl flex flex-col items-center justify-center max-w-[85vw]">
                <h3 className="text-black font-black text-xl mb-6 uppercase tracking-tighter">
                    {title}
                </h3>
                {/* `url` is the redemption code/link (the QR data), not an image URL — generate the QR,
                    same as the inline reward QR in StepResult. */}
                <QRCodeSVG
                    value={url}
                    className="w-64 h-64"
                    level="L"
                    marginSize={0}
                    fgColor="#000000"
                    bgColor="#ffffff"
                />
            </div>

            <p className="text-white/60 mt-8 font-medium animate-pulse text-sm text-center px-4">
                {t('overlay_qrcode.title')}
            </p>
        </div>
    );
};

export default QrCodeOverlay;